"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./src/core/di"));
var util_1 = require("./src/core/util");
exports.bundle = util_1.bundle;
var directives_1 = require("./src/core/directives");
exports.Directive = directives_1.Directive;
exports.Component = directives_1.Component;
exports.NgModule = directives_1.NgModule;
exports.Attr = directives_1.Attr;
exports.Input = directives_1.Input;
exports.Output = directives_1.Output;
exports.HostBinding = directives_1.HostBinding;
exports.HostListener = directives_1.HostListener;
exports.ViewChild = directives_1.ViewChild;
exports.ViewChildren = directives_1.ViewChildren;
exports.ContentChild = directives_1.ContentChild;
exports.ContentChildren = directives_1.ContentChildren;
var pipes_1 = require("./src/core/pipes");
exports.Pipe = pipes_1.Pipe;
__export(require("./src/core/change_detection"));
var lang_1 = require("./src/facade/lang");
exports.enableProdMode = lang_1.enableProdMode;
var facade_1 = require("./src/facade/facade");
exports.EventEmitter = facade_1.EventEmitter;
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/core.js
// module id = 0
// module chunks = 6